import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dashboard: localStorage.getItem('dashboard')
    ? JSON.parse(localStorage.getItem('dashboard'))
    : null,
    score: localStorage.getItem('score')
    ? JSON.parse(localStorage.getItem('score'))
    : null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setCalculations: (state, action) => {
      state.dashboard = action.payload;
      localStorage.setItem('dashboard', JSON.stringify(action.payload));
    },
    setScore: (state, action) => {
      state.score = action.payload;
      localStorage.setItem('score', JSON.stringify(action.payload));
    },
  },
});

export const { setCalculations, setScore, setRunningpnl } = dashboardSlice.actions;

export default dashboardSlice.reducer;
